import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Shipping Policy</h1>
      <p><strong>Effective Date:</strong> 12 June 2025</p>
      <p>Thank you for choosing SmileGuide. Please read our Shipping Policy to understand how digital course access is delivered after purchase.</p>

      <h3>1. Digital Products Only</h3>
      <p>All our offerings are digital educational products, including:</p>
      <ul>
        <li>Video lectures</li>
        <li>PDF notes and resources</li>
        <li>Practice questions and assignments</li>
        <li>Online tools and progress tracking systems</li>
      </ul>
      <p>There is no physical item shipped or delivered.</p>

      <h3>2. Delivery Timeline</h3>
      <p>Course access is granted immediately after successful payment and account verification.</p>
      <p>A confirmation email with login details and access instructions is sent to the registered email address.</p>
      <p>In rare cases, access may take up to 2 to 4 hours if manual verification is required.</p>

      <h3>3. Email Delivery</h3>
      <p>Please ensure that:</p>
      <ul>
        <li>Your email address is entered correctly at checkout.</li>
        <li>You check your inbox, spam, or promotions folder for the confirmation email.</li>
      </ul>
      <p>If you do not receive an email within 4 hours of payment, contact our support team at <strong>support@smileguide.example</strong>.</p>

      <h3>4. No Physical Shipping</h3>
      <p>We do not deliver any CDs, books, printed materials, or hardware.</p>
      <p>All course materials remain accessible online through your account during the validity period (1 year from purchase).</p>

      <h3>5. Access Support</h3>
      <p>If you face any technical issue while accessing your course:</p>
      <ul>
        <li>Visit our Help or Support section, or</li>
        <li>Email us at <strong>support@smileguide.example</strong> with your registered name, email, and payment details.</li>
      </ul>

      <h3>6. Registered Address (For Communication)</h3>
      <p>
        SmileGuide<br />
        Registered business address and contact details go here.<br />
        India
      </p>
    </div>
  );
};

export default ShippingPolicy;
